import axios from "axios";
import _ from "lodash";
import Vue from 'vue'

// const headers = {"Content-Type": "application/json", "X-CSRF-Token": document.querySelector("meta[name='csrf-token']").content};


const AchievementTuningStore = {
    namespaced: true,
    state: ()=>({
        current_item_tab: "SettingAchievements",
        list_portfolios: [],
        secondary_color: '#E3F2FD',
        loading_portfolios: true
    }),

    getters: {

    },

    mutations: {

        setCurrentItemTab: (state, tab_item) => state.current_item_tab = tab_item,

        setListPortfolios: (state, response) => state.list_portfolios = response,

        setLoadingPortfolios: (state, flag) => state.loading_portfolios = flag,

    },

    actions: {

        async getListPortfolios({commit}) {
            await axios.get(`/portfolio/get_portfolios.json`)
                .then((response) => commit('setListPortfolios', response.data.portfolios))
                .catch(errors => console.log(errors))
                .finally(() => commit('setLoadingPortfolios', false))
        },



    },
}

export default AchievementTuningStore